import { atom, selector } from "recoil";
import {
    DEFAULT_LANG,
    I18N_OTA,
    I18nRecord,
    loadTranslation,
    STATIC_TRANSLATIONS,
} from "../i18n/config";
import { getLocales } from "expo-localization";

const locales = getLocales();

const get_default_lang = () => {
    return locales?.[0]?.languageCode || DEFAULT_LANG;
};
export const currentLang = atom({
    key: "CurrentLang",
    default: get_default_lang(),
});

export const currentTranslations = selector<I18nRecord>({
    key: "CurrentTranslations",
    get: ({ get }) => {
        const lang = get(currentLang);
        let translation = null;
        if (I18N_OTA) {
            translation = loadTranslation(lang);
        } else {
            translation = STATIC_TRANSLATIONS[lang] || STATIC_TRANSLATIONS[DEFAULT_LANG];
        }
        return translation;
    },
});
